export const PERMISSION_COLUMNS_DISPLAY = [
  'DocumentCreate',
  'DocumentRead',
  'DocumentUpdate',
  'DocumentDelete',
  'MetaCreate',
  'MetaRead',
  'RolesCreate',
  'RolesRead',
  'RolesUpdate',
  'RolesDelete',
  'UsersCreate',
  'UsersRead',
  'UsersUpdate',
  'UsersDelete',
  'ExternalUserCreate',
  'ScannerCreate',
  'PagesCreate',
  'PagesDelete',
  'AnnotationsUpdate',
  'OrganizerCreate',
  'PrintingLeadSheetsCreate',
  'EmptyTrashCreate',
  'TrashDocumentsCreate',
  'AuditLogRead',
];

export const PERMISSION_COLUMNS = PERMISSION_COLUMNS_DISPLAY.map((c) => c.toLowerCase());
